import { getSocialApi } from "../../api/home/socialApi";
import {
  GET_SOCIAL_SUCCESS,
  GET_SOCIAL_FAILURE,
} from "../types";

export const getSocialSuccess = (data) => ({
  type: GET_SOCIAL_SUCCESS,
  payload: data,
});

export const getSocialFailure = (error) => ({
  type: GET_SOCIAL_FAILURE,
  payload: error,
});

export const getSocial = (postData) => {
  return (dispatch) => {
    getSocialApi(postData)
      .then((response) => {
        dispatch(getSocialSuccess(response.data));
      })
      .catch((error) => {
        dispatch(getSocialFailure(error.message));
      });
  };
};
